// Tablet range of the header mega menu (768-1279px). Above it the desktop layout
// applies and nothing here is consulted.
export const TABLET_MIN_WIDTH = 768
export const TABLET_MAX_WIDTH = 1279

// Narrowest viewport at which the nav columns and the promo pane still share one
// row with usable tiles. Narrower 3-4 column menus put the pane on its own row.
// 0-2 column menus fit from the tablet floor.
const SIDE_BY_SIDE_MIN_WIDTH = { 3: 1024, 4: 1180 }

export function isTabletWidth (viewportWidth) {
  return viewportWidth >= TABLET_MIN_WIDTH && viewportWidth <= TABLET_MAX_WIDTH
}

export function sharesRowWithColumns (columnCount, viewportWidth) {
  return viewportWidth >= (SIDE_BY_SIDE_MIN_WIDTH[columnCount] || TABLET_MIN_WIDTH)
}
